import { PopoverOrigin } from '@mui/material';

/** Where the emoji picker popover opens relative to the associated input. */
export type EmojiPickerPosition = 'left' | 'right' | 'bottom';

type PopoverPlacement = {
  anchorOrigin: PopoverOrigin;
  transformOrigin: PopoverOrigin;
};

/** Maps a logical picker position to MUI Popover origin props. */
export const emojiPickerPlacementByPosition: Record<EmojiPickerPosition, PopoverPlacement> = {
  left: {
    anchorOrigin: { vertical: 'top', horizontal: 'left' },
    transformOrigin: { vertical: 'top', horizontal: 'right' },
  },
  right: {
    anchorOrigin: { vertical: 'top', horizontal: 'right' },
    transformOrigin: { vertical: 'top', horizontal: 'left' },
  },
  bottom: {
    anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
    transformOrigin: { vertical: 'top', horizontal: 'right' },
  },
};
